@use '../../../styles/variables' as *;
@use '../../../styles/mixins' as *;

.tooltip {
  @include tooltip-base;
}

.header {
  font-weight: bold;
  font-size: $font-md;
  margin-bottom: 6px;
  color: $color-primary;
  border-bottom: 1px solid $color-secondary;
  padding-bottom: 6px;
}

.desc {
  margin-bottom: $space-sm;
  color: $color-text-dim;
  font-style: italic;
  line-height: 1.3;
}

.statsLabel {
  font-size: $font-xs;
  color: $color-text-dimmer;
  margin-bottom: $space-xs;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat {
  margin: 3px 0;
  color: $color-teal;
  line-height: 1.4;
}
